<template>
  <div class="col-12 collapse my-3" id="collapseExample">
    <div class="card card-body shadow updPwdBox">
      <div class="input-group mb-3">
        <div class="input-group-append d-none d-sm-flex px-2 border border-secondary rounded-left d-flex align-items-center">
          <span>E-mail</span>
        </div>
        <input
          type="email"
          class="form-control"
          :placeholder="data.Email"
          aria-label="Enter E-mail"
          aria-describedby="button-addon2"
          v-model="mail"
        />
        <div class="input-group-append d-none d-sm-block">
          <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="Captcha">發送驗證碼</button>
        </div>
      </div>
      <button class="btn btn-outline-secondary d-block d-sm-none" type="button" id="button-addon2" @click="Captcha">發送驗證碼</button>
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label for="oldPassword">舊的密碼</label>
            <input
              type="password"
              class="form-control"
              id="oldPassword"
              v-model="oldPwd"
            />
          </div>
          <div class="form-group">
            <label for="verification">驗證碼</label>
            <input
              type="text"
              class="form-control"
              id="verification"
              v-model="verification"
            />
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label for="newPassword">新的密碼</label>
            <input
              type="password"
              class="form-control"
              id="newPassword"
              v-model="newPwd"
            />
          </div>
          <div class="form-group">
            <label for="newPasswordAgain">確認新的密碼</label>
            <input
              type="password"
              class="form-control"
              id="newPasswordAgain"
              v-model="newPwdAgain"
            />
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-outline-secondary btn-sm btn-block" @click="updPwd">更新</button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: {},
      mail: '',
      oldPwd: '',
      newPwd: '',
      newPwdAgain: '',
      verification: ''
    }
  },
  methods: {
    Captcha () {
      const vm = this
      if (this.mail === '') {
        const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!reg.test(vm.data.Email)) {
          vm.$swal({
            position: 'top-end',
            background: '#F7ECEB',
            icon: 'error',
            title: 'E-mail格式不完整...',
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
              toast.addEventListener('mouseenter', vm.$swal.stopTimer)
              toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
            }
          })
        } else {
          const url = 'http://imrebooksystem.rocket-coding.com/businessUsers/VerificationMailSend'
          this.axios.post(url, { Email: vm.data.Email })
            .then(function (res) {
              localStorage.setItem('verification', JSON.stringify(res.data))
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '驗證碼已發送到信箱',
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
            })
            .catch(error => console.error(error))
        }
      } else {
        const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!reg.test(vm.mail)) {
          vm.$swal({
            position: 'top-end',
            background: '#F7ECEB',
            icon: 'error',
            title: 'E-mail格式不完整...',
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
              toast.addEventListener('mouseenter', vm.$swal.stopTimer)
              toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
            }
          })
        } else {
          const url = 'http://imrebooksystem.rocket-coding.com/businessUsers/VerificationMailSend'
          this.axios.post(url, { Email: vm.mail })
            .then(function (res) {
              localStorage.setItem('verification', JSON.stringify(res.data))
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '驗證碼已發送到信箱',
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
            })
            .catch(error => console.error(error))
        }
      }
    },
    updPwd () {
      const vm = this
      if (this.oldPwd === '' || this.newPwd === '' || this.newPwdAgain === '' || this.verification === '') {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'warning',
          title: '填寫不完整...',
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else if (this.newPwd !== this.newPwdAgain) {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'error',
          title: '密碼不一樣',
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else if (this.verification !== localStorage.getItem('verification')) {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'error',
          title: '驗證碼錯誤',
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else {
        var mail = !vm.mail ? mail = vm.data.Email : mail = vm.mail
        const url = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/BusinessPasswordEdit'
        vm.axios
          .post(url, {
            Email: mail,
            oldPassword: vm.oldPwd,
            newPassword: vm.newPwd,
            verification: vm.verification
          })
          .then(function (res) {
            if (res.data === '密碼修改成功') {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '修改完成',
                showConfirmButton: false,
                toast: true,
                timer: 4000,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
              vm.oldPwd = ''
              vm.newPwd = ''
              vm.newPwdAgain = ''
              vm.verification = ''
            } else {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'warning',
                title: res.data,
                showConfirmButton: false,
                toast: true,
                timer: 4000,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
            }
          })
          .catch(error => console.error(error))
      }
    }
  },
  created () {
    const adminEmail = JSON.parse(sessionStorage.getItem('admin'))
    const url = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/GetUserInfo'
    const adminDataUrl = 'http://imrebooksystem.rocket-coding.com/BusinessUsers/BusinessUserEdit'
    const vm = this
    this.axios
      .get(url, { params: { email: adminEmail } })
      .then(function (res) {
        const adminId = res.data.Id
        vm.axios
          .get(adminDataUrl, { params: { Id: adminId } })
          .then(function (res) {
            vm.data = res.data
          })
          .catch(error => console.error(error))
      })
      .catch(error => console.error(error))
  }
}
</script>

<style lang="scss">
.updPwdBox{
  background-color: transparent;
  input,
  input:focus{
    background-color: transparent;
  }
}
</style>
